import { BaseConfig } from '../ServiceConfig';

export interface MaiaConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.MaiaServiceConfigData';
  url: string;
}

export const MaiaConfigurationFields: (keyof MaiaConfiguration)[] = ['url'];

export const BlankMaiaConfiguration: MaiaConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.MaiaServiceConfigData',
} as MaiaConfiguration;
